import { Title, Text, Card } from '@tremor/react';

export function UsersPage(): JSX.Element {
  return (
    <div>
      <Title>Users</Title>
      <Card className="mt-4">
        <Text>
          Admin-only user CRUD lives at the API today (POST /api/users etc.). The UI for
          creating new admin / reviewer / dock_manager accounts ships in a follow-up — for
          MVP, run <code>npm run bootstrap-user --workspace apps/web</code> from a Railway
          shell to provision the first set.
        </Text>
      </Card>
    </div>
  );
}
